import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  ContainerStatus, CurrentAssetLocationDto, LocationServiceDto} from 'src/shared/service-proxies/service-proxies';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as moment from 'moment';
import { DateTimeHelper } from 'src/app/helpers/datetime'
import { Router } from '@angular/router';
import { AssetOnSiteModel } from 'src/app/location-detail/assets-on-site-model';

export class AssetDropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
  selector: 'app-widget-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss']
})
export class AssetsWidgetComponent implements OnChanges, OnInit {
  // Inputs
  @Input()
  containers: AssetOnSiteModel[]

  @Input()
  showFullDate: boolean = false;

  @Output()
  onExport: EventEmitter<any> = new EventEmitter();

  private isOnExportUsed = false;

  // Private variables
  containerList: AssetDropDownListItem[] = [];
  typeList: AssetDropDownListItem[] = [];
  statusList: AssetDropDownListItem[] = [];
  selectedContainerId: string;
  selectedContainerTypeId: string;
  selectedStatusId: string;
  filteredAssetsOnSite: AssetOnSiteModel[] = [];
  selectedImage: string | null = null;
  isPopupOpen = false;
  
  // Public variables
 assetsPage: AssetOnSiteModel[];

  constructor(private router: Router) { }

  ngOnChanges(changes) {
      this.updateView();
  }

  ngOnInit(): void {
    this.isOnExportUsed = this.onExport.observers.length > 0;
  }

  updateView() {
    let page: AssetOnSiteModel[] = [];

    this.addContainerLists(this.containers);
    this.containers.forEach(container => {
        page.push(container);
    });

    this.filterClientSide(this.containers)
  }

  filterClientSide(assetsOnSite: AssetOnSiteModel[]) {    
    if (assetsOnSite) {
      this.assetsPage = assetsOnSite;
    }

    let filteredAssetsOnSite = this.assetsPage;

    if(this.selectedContainerId) {
      filteredAssetsOnSite = filteredAssetsOnSite.filter(a => a.id == this.selectedContainerId);
    }
    if(this.selectedContainerTypeId) {
      filteredAssetsOnSite = filteredAssetsOnSite.filter(a => a.type == this.selectedContainerTypeId);
    }

    if(this.selectedStatusId) {
      console.log(this.selectedStatusId);
      console.log(filteredAssetsOnSite);
      filteredAssetsOnSite = filteredAssetsOnSite.filter(a => a.containerStatus == this.selectedStatusId);
    }

    this.filteredAssetsOnSite = filteredAssetsOnSite;
  }

  containerChange(newValue) {
    if (newValue) {
      this.selectedContainerId = newValue;
    } else {
      this.selectedContainerId = null;
    }

    this.filterClientSide(null);
  }

  typeChange(newValue) {
    if (newValue) {
      this.selectedContainerTypeId = newValue;
    } else {
      this.selectedContainerTypeId = null;
    }    

    this.filterClientSide(null);
  }

  statusChange(newValue) {
    if (newValue) {
      this.selectedStatusId = newValue;
    } else {
      this.selectedStatusId = null;
    }
    console.log(newValue)

    this.filterClientSide(null);
  }

  addContainerLists(assets: AssetOnSiteModel[]) {
    var containerList: AssetDropDownListItem[] = []
    var assetTypeList: AssetDropDownListItem[] = []
    var statusList: AssetDropDownListItem[] = []

    assets.forEach(asset => {
      let containerItem = new AssetDropDownListItem()
      containerItem.id = asset.id;
      containerItem.name = asset.id;
      containerList.push(containerItem)

      if (!assetTypeList.find(a => a.id == asset.type)) {
        let typeItem = new AssetDropDownListItem()
        typeItem.id = asset.type;
        typeItem.name = asset.type;
        assetTypeList.push(typeItem)
      }

      if (!statusList.find(a => a.id == asset.containerStatus.toString())) {
        let statusItem = new AssetDropDownListItem()

        statusItem.id = asset.containerStatus.toString();
        statusItem.name = this.splitByCapitalLetters(asset.containerStatus);
        statusList.push(statusItem)
      }
    });

    containerList = containerList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    assetTypeList = assetTypeList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    statusList = statusList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.containerList = containerList;
    this.typeList = assetTypeList;
    this.statusList = statusList;
  }

  splitByCapitalLetters(str) {
    if (!str) {
        return "";
    }

    return str.toString().replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  openPopup(imageSrc: string): void {
    this.selectedImage = imageSrc;
    this.isPopupOpen = true;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }
}
